// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","819":"BusinessProVisitorLazyComponent"}[chunkId] + "." + {"46":"e20c5a7ef4c5e717c679","819":"0882df9722f19b695d16"}[chunkId] + ".js";
};